import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";

/**
 * Header
 */

type Props = {
  dataDe?: Date | null;
  dataAte?: Date | null;
  status: number;
  onDataRangeChange: (valueDe: Date | null, valueAte: Date | null) => void;
  onStatusChange: (value: number) => void;
  onClear: () => void;
};

export const Header = ({
  dataDe,
  dataAte,
  status,
  onDataRangeChange,
  onStatusChange,
  onClear,
}: Props) => {
  return (
    <CascateList title="Pesquisar" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
          <div className="w-full col-span-3 grid grid-cols-3 gap-6">
            <div className="col-span-1">
              <DefaultDateRangePickerInput
                label='Data'
                dataDe={dataDe ?? null}
                dataAte={dataAte ?? null}
                onChange={async (start, end) => {
                  onDataRangeChange(start, end);
                }}
              />

            </div>

            <div className="col-span-2">
              <FormControl size="small" fullWidth>
                <InputLabel id="status">Status</InputLabel>
                <Select
                  labelId="status"
                  label="Status"
                  value={status}
                  onChange={e => onStatusChange(Number(e.target.value))}>
                  <MenuItem value={2}>Todas</MenuItem>
                  <MenuItem value={0}>Verificação Não Iniciada</MenuItem>
                  <MenuItem value={3}>Verificação Iniciada</MenuItem>
                  <MenuItem value={1}>Encerrada</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col items-end">
          <div className="w-[7.5rem]">
            <PrimaryButton buttonColor="yellow" onClick={onClear}>
              Limpar
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}